import {Config, DEFAULT_WEB_CONFIG, WEB_CONFIG} from './config';
// Angular
import {ModuleWithProviders, NgModule} from '@angular/core';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {CommonModule, DatePipe} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
// Services
import {CommonApiService} from './services/api/common-api.service';
// Modules
import {SharedModule} from 'primeng/api';
import {LocalStorageService} from './services/storage/local-storage.service';
import {InterceptorHttpService} from './services/jwt-security/interceptorhttp.service';
import {MatTableComponent} from './component/mat-table/mat-table.component';
import {MatTableFilterFragment} from './component/mat-table-filter/mat-table-filter.fragment';
import {MatchHeightDirective} from './directives/match-height.directive';
import {MyNumberFormatterDirective} from './directives/my-number-formatter-directive';
import {CapitalizefirstPipe} from './pipes/capitalizefirst.pipe';
import {SpacesNumberPipe} from './pipes/comma-separated-number.pipe';
import {SanitizeHtml} from './pipes/display-html.pipe';
import {DisplayNullPipe} from './pipes/display-null.pipe';
import {FormatNumberInput} from './pipes/format-number-input.pipe';
import {MatDividerModule} from '@angular/material/divider';
import {LocalDatePipe} from './pipes/local-date.pipe';
import {MyNumberPipe} from './pipes/my-number.pipe';
import {TrimStringPipe} from './pipes/trim-string.pipe';
import {ThemeEventsService} from './theme/theme-event.service';
import {SessionStorageService} from './services/storage/session-storage.service';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import {AutoCompleteFragment} from './component/auto-complete/auto-complete.fragment';
import {ExpenditureStatusIconComponent} from './component/icons/expenditure-status-icon/expenditure-status-icon.component';
import {VideoPurchaseOrderTypeIconComponent} from './component/icons/video-purchase-order-type-icon/video-purchase-order-type-icon.component';
import {VideoStatusIconComponent} from './component/icons/video-status-icon/video-status-icon.component';
import {PermissionsService} from './permissions/permissions.service';
import {ArrayService} from './services/array/array.service';
import {OverlayComponent} from './component/overlay/overlay.component';
import {LocationBarComponent} from './component/header/location-bar/location-bar.component';
import {HeaderComponent} from './component/header/header.component';
import {NgxPermissionsModule} from 'ngx-permissions';
import {MenuComponent} from './component/menu/menu.component';
import {RouterModule} from '@angular/router';
import {FlexModule} from '@angular/flex-layout';
import {MyDialogPopupComponent} from './component/popup/popup/popup.component';
import {NewActionsComponent} from './component/actions/new/new-actions.component';
import {TooltipModule} from 'primeng/tooltip';
import {ProgressBarComponent} from './component/progress-bar/progress-bar';
import {ErrorsComponent} from './component/error/errors.component';
import {RightPopinComponent} from './component/popin/right/right-popin.component';
import {PopinService} from './component/popin/popin.service';
import {BottomPopinComponent} from './component/popin/bottom/bottom-popin.component';
import {SubHeaderComponent} from './component/sub-header/sub-header.component';
import {MyDialogPopupLoginComponent} from './component/popup/popup-login/popup-login.component';
import {AesService} from './services/jwt-security/aes.service';
import {RequestLoaderFragment} from './component/request-loader/request-loader.fragment';
import {PaginationComponent} from './component/paginator/pagination.component';
import {IconBoxComponent} from './component/icon-box/icon-box.component';
import {InlineIconBoxComponent} from './component/inline-icon-box/inline-icon-box.component';
import {BlockComponent} from './component/block/block.component';
import {CustomTableCellContentComponent} from './component/mat-table/custom-table-cell-content.component';
import {NoaErrorPopUpComponent} from './component/popup/popupNoaError/popupNoaError.component';
import { CookieService } from 'ngx-cookie-service';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    MatTableModule,
    MatFormFieldModule,
    MatSelectModule,
    MatIconModule,
    MatDatepickerModule,
    MatDividerModule,
    MatCheckboxModule,
    MatAutocompleteModule,
    MatTooltipModule,
    MatPaginatorModule,
    MatSortModule,
    MatInputModule,
    MatChipsModule,
    TranslateModule,
    MatCardModule,
    MatProgressSpinnerModule,
    MatToolbarModule,
    NgxPermissionsModule,
    MatMenuModule,
    MatListModule,
    MatButtonModule,
    RouterModule,
    FlexModule,
    TooltipModule,
    MatDialogModule,
    MatSlideToggleModule
  ],
  declarations: [
    BlockComponent,
    MatTableComponent,
    MatTableFilterFragment,
    MatchHeightDirective,
    MyNumberFormatterDirective,
    CapitalizefirstPipe,
    SpacesNumberPipe,
    SanitizeHtml,
    DisplayNullPipe,
    FormatNumberInput,
    LocalDatePipe,
    MyNumberPipe,
    TrimStringPipe,
    AutoCompleteFragment,
    VideoStatusIconComponent,
    VideoPurchaseOrderTypeIconComponent,
    ExpenditureStatusIconComponent,
    MyDialogPopupComponent,
    OverlayComponent,
    LocationBarComponent,
    HeaderComponent,
    MenuComponent,
    NewActionsComponent,
    ProgressBarComponent,
    ErrorsComponent,
    RightPopinComponent,
    BottomPopinComponent,
    SubHeaderComponent,
    MyDialogPopupLoginComponent,
    RequestLoaderFragment,
    PaginationComponent,
    IconBoxComponent,
    CustomTableCellContentComponent,
    InlineIconBoxComponent,
    NoaErrorPopUpComponent
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorHttpService,
      multi: true
    },
    LocalStorageService,
    ThemeEventsService,
    SessionStorageService,
    LocalStorageService,
    PermissionsService,
    ArrayService,
    CommonApiService,
    DatePipe,
    LocalDatePipe,
    PopinService,
    MyNumberPipe,
    AesService,
    CookieService
  ],
  exports: [
    MatTableComponent,
    MatTableFilterFragment,
    MatchHeightDirective,
    MyNumberFormatterDirective,
    CapitalizefirstPipe,
    SpacesNumberPipe,
    SanitizeHtml,
    DisplayNullPipe,
    FormatNumberInput,
    LocalDatePipe,
    MyNumberPipe,
    TrimStringPipe,
    AutoCompleteFragment,
    OverlayComponent,
    HeaderComponent,
    MenuComponent,
    NewActionsComponent,
    ProgressBarComponent,
    ErrorsComponent,
    RightPopinComponent,
    BottomPopinComponent,
    SubHeaderComponent,
    VideoStatusIconComponent,
    VideoPurchaseOrderTypeIconComponent,
    ExpenditureStatusIconComponent,
    RequestLoaderFragment,
    PaginationComponent,
    IconBoxComponent,
    InlineIconBoxComponent,
    BlockComponent
  ],
  entryComponents: [
    MyDialogPopupLoginComponent,
    MyDialogPopupComponent,
    NoaErrorPopUpComponent
  ]
})
export class UtilModule {
  public static forRoot(
    config: Config = DEFAULT_WEB_CONFIG
  ): ModuleWithProviders<UtilModule> {
    return {
      ngModule: UtilModule,
      providers: [{ provide: WEB_CONFIG, useValue: config }]
    };
  }

  public static forChild(
    config: Config = DEFAULT_WEB_CONFIG
  ): ModuleWithProviders<UtilModule> {
    return {
      ngModule: UtilModule,
      providers: [{ provide: WEB_CONFIG, useValue: config }]
    };
  }

  constructor(
    private translate: TranslateService,
    private localStorage: LocalStorageService
  ) {
    this.translate.addLangs(['en', 'fr', 'de']);
    if (this.localStorage.exist('lang')) {
      this.translate.use(this.localStorage.get('lang'));
    } else {
      this.translate.use(
        this.translate.getLangs().indexOf(this.translate.getBrowserLang()) ===
        -1
          ? this.translate.getBrowserLang()
          : 'en'
      );
    }
    this.localStorage.post('lang', this.translate.currentLang);
  }
}
